import Util from '@/lib/util'
import _ from 'lodash'
export default [
    {
        title:Util.L('Salesman'),
        key:'salesmanId',
        width:150,
        render:(h:any,params:any)=>{
            if(_.isNil(params.row.salesman))
                return '';
            return h("span", `${params.row.salesman.userName} - ${params.row.salesman.name}`);
        }
    }
]